export const routes = [
  {
    pathname: 'regulars',
    registeredNames: ['shops'],
    children: [
      {
        pathname: 'shops',
        dynamicSegments: true,
        urls: {
          productsApi: '/subscriptions/shops/',
          pageUrl: '/regulars/shops/',
          navigationApi: '/subscriptions/subnavigation/',
        },
      },
    ],
    urls: {
      productsApi: '/subscriptions',
      pageUrl: '/regulars',
      navigationApi: '/subnavigation',
    },
  },
];
